import React, { useMemo } from 'react';
import { validateNumberValue, validateStringValue } from '../../../utils/common';
import { SkeltonCardTwo } from '../../../common/SkeltonCardTwo';
import IconToolTip from '../../../common/IconToolTip';
import OverflowTip from '../../../common/OverflowTip';

export const RenderPMs = ({ mainDivClass = 'grid grid-cols-2 p-2 gap-2 w-20vw', managers }) => {

    const pms = useMemo(() => {
        let list = [];
        list = managers.map((pm) => {
            let label = pm.role === 'EM' ? 'Escalation Manager' : `Project Manager (${pm.role})`;
            let name = validateStringValue(pm.full_name);
            let mobile = validateNumberValue(pm.mobile);
            return { ...pm, name, label, mobile };
        });
        return list;
    }, [managers]);

    return (
        <div className={mainDivClass}>
            {pms.map((pm, i) => {
                return <User pm={pm} />
            })}
        </div>
    );
}


const User = ({ pm }) => {
    return <div key={pm} className='mt-1 py-4'>
        <p className='text-scogo99 text-font11 font-medium'> {pm.label} : </p>
        <p className='flex items-center gap-2  text-font11'>
            <IconToolTip title={'Mobile Number'}>
                <span className="material-icons text-scogoorange text-font12">person</span>
            </IconToolTip>
            <OverflowTip someLongText={pm?.name} />
        </p>
        <p className='flex items-center gap-2 text-font11'>
            <IconToolTip title={'Mobile Number'}>
                <span className="material-icons text-scogoprimary text-font12">phone</span>
            </IconToolTip>
            <OverflowTip someLongText={pm?.mobile} />
        </p>
    </div>
}

export default function PMDetails({ managers }) {
    return <RenderPMs managers={managers} loaderComponent={
        <SkeltonCardTwo arr={[1, 2]} height='25' className='px-6' />
    } mainDivClass='grid grid-cols-2 p-2 gap-2 px-6' />;
}
